import { useEffect, useState } from "react";
import { HeartHandshake } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const ROWS = [
  ["notes", "Notes sent"], ["replies", "Replies"], ["hearts", "Hearts from members"], ["cheers", "Badge cheers"],
  ["video_views", "Year-video views"], ["video_hearts", "Video hearts"], ["video_notes", "Video notes"], ["active_supporters", "Active supporters"],
];

const Change = ({ now, prev }) => {
  if (now === prev) return <span className="text-mm-muted">—</span>;
  const up = now > prev;
  return <span className={up ? "text-mm-success" : "text-mm-muted"}>{up ? "▲" : "▼"} {Math.abs(now - prev)}</span>;
};

export const SupporterActivity = ({ includeTest }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/supporter-activity", { params: { include_test: includeTest } }).then((r) => setD(r.data)).catch((e) => logError("Supporter activity failed:", e));
  }, [includeTest]);
  if (!d) return null;
  return (
    <div className="mm-card p-5 mt-6" data-testid="admin-supporter-activity">
      <div className="font-semibold flex items-center gap-2"><HeartHandshake size={18} /> Supporter activity</div>
      <div className="text-sm text-mm-muted">Totals across all members, with no names or message text.{!includeTest && " Test data hidden."}</div>
      <div className="grid grid-cols-[1fr_auto_auto_auto] gap-x-5 gap-y-2 mt-4 text-sm">
        <span className="text-xs text-mm-muted" />
        <span className="text-xs text-mm-muted text-right">{d.this_month.label}</span>
        <span className="text-xs text-mm-muted text-right">{d.last_month.label}</span>
        <span className="text-xs text-mm-muted text-right">Change</span>
        {ROWS.map(([k, label]) => [
          <span key={`${k}-l`}>{label}</span>,
          <span key={`${k}-a`} className="text-right font-semibold" data-testid={`activity-${k}-this`}>{d.this_month[k]}</span>,
          <span key={`${k}-b`} className="text-right text-mm-muted" data-testid={`activity-${k}-last`}>{d.last_month[k]}</span>,
          <span key={`${k}-c`} className="text-right text-xs"><Change now={d.this_month[k]} prev={d.last_month[k]} /></span>,
        ])}
      </div>
    </div>
  );
};
